// Age confirmation for checkout. The cart page and cart drawer both render
// snippets/kneecap-age-confirm.liquid above the checkout button; the drawer is
// re-rendered on every cart change, so everything here uses event delegation.
(function () {
  var ATTR = 'Age confirmed';
  var ATTR_AT = 'Age confirmed at';
  var pendingSave = null;
  var syncQueued = false;

  function checkoutButtons() {
    return document.querySelectorAll('.cart__checkout-button[name="checkout"]');
  }

  function isConfirmed() {
    var box = document.querySelector('[data-kn-age-confirm]');
    return !!(box && box.checked);
  }

  function setError(show) {
    document.querySelectorAll('.kn-age-confirm').forEach(function (label) {
      label.classList.toggle('kn-age-confirm--error', show);
    });
    // Filling the role="alert" paragraph is what screen readers announce.
    document.querySelectorAll('[data-kn-age-error]').forEach(function (error) {
      error.textContent = show ? error.dataset.message : '';
    });
  }

  function sync() {
    var confirmed = isConfirmed();
    document.querySelectorAll('[data-kn-age-confirm]').forEach(function (box) {
      box.checked = confirmed;
    });
    checkoutButtons().forEach(function (button) {
      if (!document.querySelector('[data-kn-age-confirm]')) return;
      if (confirmed) {
        button.removeAttribute('data-kn-age-locked');
        button.removeAttribute('aria-disabled');
      } else {
        button.setAttribute('data-kn-age-locked', '');
        button.setAttribute('aria-disabled', 'true');
      }
    });
    // Express checkout skips the checkout button, so only show it once confirmed.
    document.querySelectorAll('[data-kn-express]').forEach(function (express) {
      express.hidden = !confirmed;
    });
  }

  // Coalesce DOM mutations into at most one sync per frame.
  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () {
      syncQueued = false;
      sync();
    });
  }

  function save(confirmed) {
    var attributes = {};
    attributes[ATTR] = confirmed ? 'Yes' : '';
    attributes[ATTR_AT] = confirmed ? new Date().toISOString() : '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var request = fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {});
    pendingSave = request;
    request.then(function () {
      if (pendingSave === request) pendingSave = null;
    });
    return request;
  }

  document.addEventListener('change', function (event) {
    var box = event.target.closest && event.target.closest('[data-kn-age-confirm]');
    if (!box) return;
    document.querySelectorAll('[data-kn-age-confirm]').forEach(function (other) {
      other.checked = box.checked;
    });
    if (box.checked) setError(false);
    sync();
    save(box.checked);
  });

  // Block checkout until confirmed, whichever way the form is submitted.
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('.cart__checkout-button[name="checkout"]');
      if (!button || !document.querySelector('[data-kn-age-confirm]')) return;
      if (isConfirmed()) {
        // Let the "Age confirmed" save land before leaving for checkout.
        if (pendingSave) {
          event.preventDefault();
          event.stopPropagation();
          pendingSave.then(function () {
            button.click();
          });
        }
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      setError(true);
      var box = document.querySelector('[data-kn-age-confirm]');
      if (box) {
        box.focus({ preventScroll: true });
        box.closest('.kn-age-confirm').scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.name === 'checkout' && !isConfirmed() && document.querySelector('[data-kn-age-confirm]')) {
        event.preventDefault();
      }
    },
    true
  );

  // Re-apply the lock after the drawer / cart sections re-render.
  new MutationObserver(queueSync).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', sync);
})();
